import { urls } from "../../constants";
import { axiosService } from "../axios.service";

const dietModeService = {
  getAll: () => axiosService.get(urls.settings.dietMode).then(value => value.data),
  getByDietTypeId: (dietTypeId) => axiosService.get(`${urls.settings.dietMode}?dietTypeId=${dietTypeId}`).then(value => value.data),
  createDietMode: (data) => axiosService.post(urls.settings.dietMode, data).then((value) => value.data),
  updateById: (id, data) => axiosService.patch(`${urls.settings.dietMode}/${id}`, data).then((value) => value.data),
  deleteById: (id) => axiosService.destroy(`${urls.settings.dietMode}/${id}`),
};

export {
  dietModeService
}

